import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class UsersService {

  private url: string = "http://localhost:8090/CARM/ddmf/getBlackListCustomers?searchKey=";

  constructor(private http: Http) { }

  getUsers(key){
    return this.http.get(this.url+key)
      .map(res => res.json());
  }

  getUser(id){
    return this.http.get(this.getUserUrl(name))
      .map(res => res.json());
  }

  addUser(user){
    return this.http.post(this.url, JSON.stringify(user))
      .map(res => res.json());
  }

  updateUser(user){
    return this.http.put(this.getUserUrl(user.name), JSON.stringify(user))
      .map(res => res.json());
  }

  deleteUser(name){
    return this.http.delete(this.getUserUrl(name))
      .map(res => res.json());
  }

  private getUserUrl(name){
    return this.url + "/" + name;
  }
}



// WEBPACK FOOTER //
// ./src/app/users/shared/users.service.ts